const initialCaseDetails = {
    caseDetailsPermissions: {},
    caseDocumentDetailsPermissions: {},
    caseDetailsLists: [],
    caseDocumentDetailsLists: [],
    caseLogsLists: [],
    caseDetailsCount: [],
    caseDocumentDetailsCount: [],
    caseDetailsMenudata: {},
    caseStatusCount: [],
    caseDetailsStatus: [],
    changedCaseDetailsStatus: [],
    dynamicReportStatus: [],
    loadingCaseDetails: false,
    errorsCaseDetails: {},
    changedDynamicReportStatus: [],
    motorCaseDetailsPermissions: {},
    motorCaseDocumentDetailsPermissions: {},
    motorCaseDetailsLists: [],
    motorCaseDocumentDetailsLists: [],
    motorCaseLogsLists: [],
    motorCaseDetailsCount: [],
    motorCaseDocumentDetailsCount: [],
    motorCaseDetailsMenudata: {},
    motorCaseStatusCount: [],
    motorCaseDetailsStatus: [],
    changedMotorCaseDetailsStatus: [],
    motorDynamicReportStatus: [],
    loadingMotorCaseDetails: false,
    errorsMotorCaseDetails: {},
    changedMotorDynamicReportStatus: [],
}

const caseDetailsReducer = (caseDetails = initialCaseDetails, action) => {
    switch (action.type) {
        case "GET_CASE_DETAILS_LIST_PENDING":
        case "GET_DYNAMIC_REPORT_PENDING":
        case "SAVE_DYNAMIC_REPORT_PENDING":
        case "ADD_CASE_INITIATED_PENDING":
        case "ADD_INTERNAL_TRIGGER_PENDING":
        case "UPDATE_PENDING_DOCUMENT_PENDING":
        case "GET_PENDING_CASE_DETAILS_LIST_PENDING":
        case "ADD_CASE_GENERATED_PENDING":
        case "ADD_ASSIGN_FIELD_OFFICER_PENDING":
        case "REVOKE_ASSIGN_FIELD_OFFICER_PENDING":
        case "ADD_ASSIGN_BACKEND_OFFICER_PENDING":
        case "ADD_CASE_DOCUMENTS_PENDING":
        case "DELETE_CASE_DOCUMENT_PENDING":
        case "ADD_QC_STATUS_REPORTS_PENDING":
        case "ADD_FIELD_QC_STATUS_REPORTS_PENDING":
        case "ADD_IS_CLOSED_PENDING":
        case "UPDATE_CASE_STATUS_PENDING":
        case "ADD_CASE_RATING_PENDING":
        case "UPDATE_CASE_DETAILS_PENDING":
        case "ADD_INITIAL_REPORT_DOCUMENTS_PENDING":
        case "GET_CASE_LOGS_LISTBYID_PENDING":
            return { ...caseDetails, loadingCaseDetails: true };

        case "GET_CASE_DETAILS_LIST_FULFILLED":
            return {
                ...caseDetails,
                loadingCaseDetails: false,
                caseDetailsLists: action.payload,
                caseDetailsCount: action.count,
                caseDetailsPermissions: action.permissions,
                caseDetailsMenudata: action.menuData,
                caseStatusCount: action.caseStatusCount || [],
            };

        case "GET_PENDING_CASE_DETAILS_LIST_FULFILLED":
            return {
                ...caseDetails,
                loadingCaseDetails: false,
                caseDocumentDetailsLists: action.payload,
                caseDocumentDetailsCount: action.count,
                caseDocumentDetailsPermissions: action.permissions
            };

        case "GET_DYNAMIC_REPORT_FULFILLED":
            return {
                ...caseDetails,
                loadingCaseDetails: false,
                dynamicReportStatus: action.payload,
            };

        case "SAVE_DYNAMIC_REPORT_FULFILLED":
            return {
                ...caseDetails,
                loadingCaseDetails: false,
                changedDynamicReportStatus: action.payload,
            };

        case "UPDATE_PENDING_DOCUMENT_FULFILLED":
            return {
                ...caseDetails,
                loadingCaseDetails: false,
                changedCaseDetailsStatus: action.payload,
            };

        case "ADD_CASE_INITIATED_FULFILLED":
            return {
                ...caseDetails,
                loadingCaseDetails: false,
                changedCaseDetailsStatus: action.payload,
            };

        case "ADD_INTERNAL_TRIGGER_FULFILLED":
            return {
                ...caseDetails,
                loadingCaseDetails: false,
                changedCaseDetailsStatus: action.payload,
            };

        case "ADD_CASE_GENERATED_FULFILLED":
            return {
                ...caseDetails,
                loadingCaseDetails: false,
                changedCaseDetailsStatus: action.payload,
            };

        case "ADD_ASSIGN_FIELD_OFFICER_FULFILLED":
            return {
                ...caseDetails,
                loadingCaseDetails: false,
                changedCaseDetailsStatus: action.payload,
            };

        case "ADD_ASSIGN_BACKEND_OFFICER_FULFILLED":
            return {
                ...caseDetails,
                loadingCaseDetails: false,
                changedCaseDetailsStatus: action.payload,
            };

        case "ADD_CASE_DOCUMENTS_FULFILLED":
            return {
                ...caseDetails,
                loadingCaseDetails: false,
                changedCaseDetailsStatus: action.payload,
            };

        case "DELETE_CASE_DOCUMENT_FULFILLED":
            return {
                ...caseDetails,
                loadingCaseDetails: false,
                changedCaseDetailsStatus: action.payload,
            };

        case "ADD_INITIAL_REPORT_DOCUMENTS_FULFILLED":
            return {
                ...caseDetails,
                loadingCaseDetails: false,
                changedCaseDetailsStatus: action.payload,
            };

        case "ADD_QC_STATUS_REPORTS_FULFILLED":
            return {
                ...caseDetails,
                loadingCaseDetails: false,
                changedCaseDetailsStatus: action.payload,
            };

        case "ADD_FIELD_QC_STATUS_REPORTS_FULFILLED":
            return {
                ...caseDetails,
                loadingCaseDetails: false,
                changedCaseDetailsStatus: action.payload,
            };

        case "ADD_IS_CLOSED_FULFILLED":
            return {
                ...caseDetails,
                loadingCaseDetails: false,
                changedCaseDetailsStatus: action.payload,
            };

        case "UPDATE_CASE_STATUS_FULFILLED":
            return {
                ...caseDetails,
                loadingCaseDetails: false,
                changedCaseDetailsStatus: action.payload,
            };

        case "ADD_CASE_RATING_FULFILLED":
            return {
                ...caseDetails,
                loadingCaseDetails: false,
                changedCaseDetailsStatus: action.payload,
            };

        case "REVOKE_ASSIGN_FIELD_OFFICER_FULFILLED":
            return {
                ...caseDetails,
                loadingCaseDetails: false,
                changedCaseDetailsStatus: action.payload,
            };

        case "GET_CASE_DETAILS_LISTBYID_FULFILLED":
            return {
                ...caseDetails,
                loadingCaseDetails: false,
                caseDetailsLists: action.payload
            };

        case "UPDATE_CASE_DETAILS_FULFILLED":
            return {
                ...caseDetails,
                loadingCaseDetails: false,
                changedCaseDetailsStatus: action.payload,
            };

        case "GET_CASE_LOGS_LISTBYID_FULFILLED":
            return {
                ...caseDetails,
                loadingCaseDetails: false,
                caseLogsLists: action.payload
            };

        case "RESET_DELETE_CASE_DETAILS_STATUS":
            return {
                ...caseDetails,
                loadingCaseDetails: false,
                caseDetailsStatus: {},
                changedCaseDetailsStatus: [],
                errorsCaseDetails: {}
            };

        case "CLEAR_DYNAMIC_REPORT_STATUS":
            return {
                ...caseDetails,
                dynamicReportStatus: [],
            };

        case "GET_CASE_DETAILS_LIST_REJECTED":
        case "GET_DYNAMIC_REPORT_REJECTED":
        case "SAVE_DYNAMIC_REPORT_REJECTED":
        case "ADD_CASE_INITIATED_REJECTED":
        case "ADD_INTERNAL_TRIGGER_REJECTED":
        case "ADD_CASE_GENERATED_REJECTED":
        case "ADD_ASSIGN_FIELD_OFFICER_REJECTED":
        case "ADD_ASSIGN_BACKEND_OFFICER_REJECTED":
        case "ADD_CASE_DOCUMENTS_REJECTED":
        case "DELETE_CASE_DOCUMENT_REJECTED":
        case "UPDATE_CASE_DETAILS_REJECTED":
        case "REVOKE_ASSIGN_FIELD_OFFICER_REJECTED":
        case "UPDATE_PENDING_DOCUMENT_REJECTED":
        case "ADD_INITIAL_REPORT_DOCUMENTS_REJECTED":
        case "ADD_QC_STATUS_REPORTS_REJECTED":
        case "ADD_FIELD_QC_STATUS_REJECTED":
        case "ADD_IS_CLOSED_REJECTED":
        case "UPDATE_CASE_STATUS_REJECTED":
        case "ADD_CASE_RATING_REJECTED":
        case "GET_CASE_DETAILS_LISTBYID_REJECTED":
        case "GET_CASE_LOGS_LISTBYID_REJECTED":
            return {
                ...caseDetails,
                loadingCaseDetails: false,
                errorsCaseDetails: action.payload
            };

        // ==================== Motor Case ====================
        case "GET_MOTOR_CASE_DETAILS_LIST_PENDING":
        case "GET_MOTOR_DYNAMIC_REPORT_PENDING":
        case "SAVE_MOTOR_DYNAMIC_REPORT_PENDING":
        case "ADD_MOTOR_CASE_INITIATED_PENDING":
        case "ADD_MOTOR_INTERNAL_TRIGGER_PENDING":
        case "UPDATE_MOTOR_PENDING_DOCUMENT_PENDING":
        case "GET_MOTOR_PENDING_CASE_DETAILS_LIST_PENDING":
        case "ADD_MOTOR_CASE_GENERATED_PENDING":
        case "ADD_MOTOR_ASSIGN_FIELD_OFFICER_PENDING":
        case "REVOKE_MOTOR_ASSIGN_FIELD_OFFICER_PENDING":
        case "ADD_MOTOR_ASSIGN_BACKEND_OFFICER_PENDING":
        case "ADD_MOTOR_CASE_DOCUMENTS_PENDING":
        case "DELETE_MOTOR_CASE_DOCUMENT_PENDING":
        case "ADD_MOTOR_QC_STATUS_REPORTS_PENDING":
        case "ADD_MOTOR_FIELD_QC_STATUS_REPORTS_PENDING":
        case "ADD_MOTOR_IS_CLOSED_PENDING":
        case "UPDATE_MOTOR_CASE_STATUS_PENDING":
        case "ADD_MOTOR_CASE_RATING_PENDING":
        case "UPDATE_MOTOR_CASE_DETAILS_PENDING":
        case "ADD_MOTOR_INITIAL_REPORT_DOCUMENTS_PENDING":
        case "GET_MOTOR_CASE_LOGS_LISTBYID_PENDING":
            return { ...caseDetails, loadingMotorCaseDetails: true };

        case "GET_MOTOR_CASE_DETAILS_LIST_FULFILLED":
            return {
                ...caseDetails,
                loadingMotorCaseDetails: false,
                motorCaseDetailsLists: action.payload,
                motorCaseDetailsCount: action.count,
                motorCaseDetailsPermissions: action.permissions,
                motorCaseDetailsMenudata: action.menuData,
                motorCaseStatusCount: action.caseStatusCount || [],
            };

        case "GET_MOTOR_PENDING_CASE_DETAILS_LIST_FULFILLED":
            return {
                ...caseDetails,
                loadingMotorCaseDetails: false,
                motorCaseDocumentDetailsLists: action.payload,
                motorCaseDocumentDetailsCount: action.count,
                motorCaseDocumentDetailsPermissions: action.permissions
            };

        case "GET_MOTOR_DYNAMIC_REPORT_FULFILLED":
            return {
                ...caseDetails,
                loadingMotorCaseDetails: false,
                motorDynamicReportStatus: action.payload,
            };

        case "SAVE_MOTOR_DYNAMIC_REPORT_FULFILLED":
            return {
                ...caseDetails,
                loadingMotorCaseDetails: false,
                changedMotorDynamicReportStatus: action.payload,
            };

        case "UPDATE_MOTOR_PENDING_DOCUMENT_FULFILLED":
        case "ADD_MOTOR_CASE_INITIATED_FULFILLED":
        case "ADD_MOTOR_INTERNAL_TRIGGER_FULFILLED":
        case "ADD_MOTOR_CASE_GENERATED_FULFILLED":
        case "ADD_MOTOR_ASSIGN_FIELD_OFFICER_FULFILLED":
        case "ADD_MOTOR_ASSIGN_BACKEND_OFFICER_FULFILLED":
        case "ADD_MOTOR_CASE_DOCUMENTS_FULFILLED":
        case "DELETE_MOTOR_CASE_DOCUMENT_FULFILLED":
        case "ADD_MOTOR_INITIAL_REPORT_DOCUMENTS_FULFILLED":
        case "ADD_MOTOR_QC_STATUS_REPORTS_FULFILLED":
        case "ADD_MOTOR_FIELD_QC_STATUS_REPORTS_FULFILLED":
        case "ADD_MOTOR_IS_CLOSED_FULFILLED":
        case "UPDATE_MOTOR_CASE_STATUS_FULFILLED":
        case "ADD_MOTOR_CASE_RATING_FULFILLED":
        case "REVOKE_MOTOR_ASSIGN_FIELD_OFFICER_FULFILLED":
        case "UPDATE_MOTOR_CASE_DETAILS_FULFILLED":
            return {
                ...caseDetails,
                loadingMotorCaseDetails: false,
                changedMotorCaseDetailsStatus: action.payload,
            };

        case "GET_MOTOR_CASE_DETAILS_LISTBYID_FULFILLED":
            return {
                ...caseDetails,
                loadingMotorCaseDetails: false,
                motorCaseDetailsLists: action.payload
            };

        case "GET_MOTOR_CASE_LOGS_LISTBYID_FULFILLED":
            return {
                ...caseDetails,
                loadingMotorCaseDetails: false,
                motorCaseLogsLists: action.payload
            };

        case "RESET_MOTOR_CASE_DETAILS_STATUS":
            return {
                ...caseDetails,
                loadingMotorCaseDetails: false,
                motorCaseDetailsStatus: {},
                changedMotorCaseDetailsStatus: [],
                errorsMotorCaseDetails: {}
            };

        case "CLEAR_MOTOR_DYNAMIC_REPORT_STATUS":
            return {
                ...caseDetails,
                motorDynamicReportStatus: [],
            };

        case "GET_MOTOR_CASE_DETAILS_LIST_REJECTED":
        case "GET_MOTOR_DYNAMIC_REPORT_REJECTED":
        case "SAVE_MOTOR_DYNAMIC_REPORT_REJECTED":
        case "ADD_MOTOR_CASE_INITIATED_REJECTED":
        case "ADD_MOTOR_INTERNAL_TRIGGER_REJECTED":
        case "ADD_MOTOR_CASE_GENERATED_REJECTED":
        case "ADD_MOTOR_ASSIGN_FIELD_OFFICER_REJECTED":
        case "ADD_MOTOR_ASSIGN_BACKEND_OFFICER_REJECTED":
        case "ADD_MOTOR_CASE_DOCUMENTS_REJECTED":
        case "DELETE_MOTOR_CASE_DOCUMENT_REJECTED":
        case "UPDATE_MOTOR_CASE_DETAILS_REJECTED":
        case "REVOKE_MOTOR_ASSIGN_FIELD_OFFICER_REJECTED":
        case "UPDATE_MOTOR_PENDING_DOCUMENT_REJECTED":
        case "ADD_MOTOR_INITIAL_REPORT_DOCUMENTS_REJECTED":
        case "ADD_MOTOR_QC_STATUS_REPORTS_REJECTED":
        case "ADD_MOTOR_FIELD_QC_STATUS_REPORTS_REJECTED":
        case "ADD_MOTOR_IS_CLOSED_REJECTED":
        case "UPDATE_MOTOR_CASE_STATUS_REJECTED":
        case "ADD_MOTOR_CASE_RATING_REJECTED":
        case "GET_MOTOR_CASE_DETAILS_LISTBYID_REJECTED":
        case "GET_MOTOR_CASE_LOGS_LISTBYID_REJECTED":
            return {
                ...caseDetails,
                loadingMotorCaseDetails: false,
                errorsMotorCaseDetails: action.payload
            };

        default:
            return caseDetails;
    }
}

export default caseDetailsReducer;